<template>
<div class="page">
    <panel ref="panel" :extinfo="extinfo" :wapTitle="''" :appLink="appLink" :spreadID="'0'" :showNav="false" :isShowNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
    <header class="header greenHeader">
        <a href="javascript:;" class="goBack" @click="goBack()" v-if="!isWx && !fromId"></a>
        <span class="icon_share" @click="alertInfo" v-if="!isWx && fromId!=1"></span>
        <h3></h3>
        <div @click.stop="followFun(info)" class="followBox" :style="info.isFocus==0?'color: #fff;':'color: #F6344B;'">
            <img v-if="info.isFocus==1" src="../../assets/img/Component 22@2x.png">
            <img v-if="info.isFocus==0" src="../../assets/img/Component 21@2x.png">
        </div>
    </header>
    <div class="speDetail" @click="toMeetDetail">
        <div class="speName">{{ meetName }}
            <img v-if="info.isZhongpai==1" @click.stop="gyFun(info)" class="gyImg" src="@/assets/img/Frame205@2x.png" alt="">
        </div>

        <div class="speInfo">
            <span class="moreBtn"></span>
            <template v-for="(item, index) in detailInfo">
                <div :key="index" v-if="item.label == '电话' && item.text">
                    <p>{{ item.label }}：{{ item.text }}</p>
                </div>
                <div :key="index" v-if="item.label == '地址' && item.text">
                    <p>{{ item.label }}：{{ item.text }}</p>
                </div>
            </template>
            <template v-for="(item, index) in detailInfo">
                <div :key="index+'license'"  @click="goLink(item.link)"  v-if="item.label == '证照' && item.text">
                    <p>{{ item.label }}：{{ item.text }}</p>
                </div>
            </template>
            <div class="loading" v-if="loading">
                <van-loading type="spinner" />
            </div>
        </div>
        <div class="imgCenter">
            <img :src="picUrl" alt="" />
        </div>
    </div>
    <div class="meetingList">
        <van-tabs v-model="active" @click="tabSc()">
            <template v-for="(year,i) in yearList">
                <van-tab :title="year" :key="i">
                    <Auction :Year="parseInt(year)" :showWater="showWater"></Auction>
                </van-tab>
            </template>
        </van-tabs>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <gyBox ref="gyBox"></gyBox>
    <watermark v-if="showWater"></watermark>
</div>
</template>

<script>
import {
    getMeeting
} from "@/api/meeting";
import Auction from "./component/auction"
import {
    indexFocus
} from "@/api/index";
import {
    mapActions,
    mapGetters
} from "vuex";
import {
    alertInfo,
    getWXConfig
} from "@/assets/js/weixinShare";
import panel from "@/views/preview/component/panel.vue";
import DownLoadApp from '@/components/common/downloadApp'
import gyBox from "@/components/common/gyBox";
import {
    isWeixin
} from "@/api/auction/isWeixin";
import watermark from "@/components/common/watermark";
import {
    Toast
} from "vant";
import {
    scMdFunc,
    gotoLogin
} from "@/assets/js/scData";
export default {
    name: "session",
    data() {
        return {
            waterLink: '',
            isBackShow: false,
            showWater: false,
            sessData: null, //整个的返回值
            meetName: "",
            detailInfo: [],
            info: {
                isFocus: 0
            },
            picUrl: '', //图片
            organCode: '',
            extinfo: '',
            active: 0,
            isWx: false,
            yearList: [],
            appLink: '/2/2/' + this.$route.params.organCode,
            fromId: this.$route.query.from,
            loading: true
        };
    },
    created() {
        if (this.$route.query.from) {
            this.showWater = true
            this.waterLink = '&from=' + this.$route.query.from
        }

    },
    //服务端渲染
    asyncData({
        store,
        route
    }) {
        let params = {
            organCode: route.params.organCode,
            only_meta: 1
        }
        return store.dispatch("pageMeeting/getPageMeeting", [params, null, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageMeeting/getIsLoadIng",
            getData: "pageMeeting/getData",
        }),
    },
    mounted() {
        if (isWeixin()) {
            this.isWx = true
        }
        if (!this.getIsLoadIng) {
            let params = {
                organCode: this.$route.params.organCode,
                only_meta: 1
            }
            this.getPageMeeting([params, () => {
                this.filteData();
            }])
        } else {
            this.filteData();
        }
        this.getMeetDetail()
        let that = this;
        that.extinfo=JSON.stringify({url: "organ",param: that.$route.params.organCode})
    },

    methods: {
        ...mapActions({
            getPageMeeting: "pageMeeting/getPageMeeting"
        }),
        goLink(e){
            window.location.href=e;
        },
        gyFun(e) {
            this.$refs.gyBox.showGY(true,{cover:e.organUrl,name:e.name});
        },
        tabSc(){
            scMdFunc('allClick', {
                cur_page: '32',
                cur_moudle: '32-3',
                cur_button: '32-3-1',
            })
        },
        followFun(e) {
            let parmas = {
                special_type: 4,
                action: e.isFocus == 0 ? 1 : 2,
                code: e.organCode,
            }
            scMdFunc('allClick', {
                cur_page: '32',
                cur_moudle: '32-1',
                cur_button: '32-1-1',
            })
            if (!e.isLogin) { //未登录
                gotoLogin()
            } else {
                indexFocus(parmas).then((res) => {
                    if (res.code == 0) {
                        if (e.isFocus == 0) {
                            this.$toast('关注成功')
                        }

                        e.isFocus = e.isFocus == 0 ? 1 : 0;

                    }
                })
            }

        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload(this.appLink, 0)
        },
        filteData() {
            this.meetName = this.$store.state["pageMeeting"]["data"].name;
            this.picUrl = this.$store.state["pageMeeting"]["data"].organUrl
            this.yearList = this.$store.state["pageMeeting"]["data"].yearList
            let data = this.$store.state["pageMeeting"]["data"]
            let iframe = document.createElement("iframe")
            //设置标题
            document.title = data.meta ? data.meta.title : '';
            document.body.appendChild(iframe)
            //刷新后移除iframe
            setTimeout(function () {
                document.body.removeChild(iframe)
            }, 0);
            // document.title = data.meta ? data.meta.title :'';
            // console.log(document.title)
            let head = document.getElementsByTagName('head');
            if (!document.querySelector('meta[name=description]')) {
                let meta = document.createElement('meta');
                meta.name = 'description';
                meta.content = data.meta ? data.meta.description : '';
                head[0].appendChild(meta)
            } else {
                document.querySelector('meta[name=description]').setAttribute('content', data.meta ? data.meta.description : '')
            }
            window.AFedWxShareData = {
                title: data.shareMessage ? data.shareMessage.shareTitle : '',
                imgUrl: data.shareMessage.pic || 'https://pubunder.artron.net/pubimgs/m/wxImgAuc.png',
                desc: data.shareMessage.description || '',
                link: window.location.href
            }
            getWXConfig(window.AFedWxShareData)
        },
        goBack() {
            this.$router.back()
            // if (document.referrer) {
            //     window.location.href = document.referrer
            // } else if(window.history.state) {
            //     this.$router.back()
            // }else if(this.$route.query.fromlink){
            //     window.location.href=decodeURIComponent(this.$route.query.fromlink)
            // } else{
            //     this.$router.push({ path: "/" });
            // }
        },
        alertInfo() {
            scMdFunc('allClick', {
                cur_page: '32',
                cur_moudle: '32-1',
                cur_button: '32-1-2',
            })
            alertInfo('分享时请使用浏览器自身的分享工具')
        },
        // 顶部跳转拍卖公司/名称
        toMeetDetail() {
            this.$router.push({
                name: 'organdetail',
                query: {
                    organCode: this.$route.params.organCode,
                    from: this.$route.query.from
                }
            });
        },
        // 路由跳转
        toSpecial(item) {
            this.$router.push({
                path: "/special/" + item.specialCode + this.waterLink
            });
        },
        // 调取接口
        getMeetDetail() {
            let that = this
            getMeeting({
                organCode: this.$route.params.organCode,
                only_meta: 0
            }).then((res) => {
                if (res.code == 0) {
                    this.info = res.data
                    this.meetName = res.data.name;
                    this.picUrl = res.data.organUrl
                    this.yearList = res.data.yearList
                    let orgDetail = res.data.detailExtraInfo
                    this.detailInfo = orgDetail.reverse()
                    this.loading = false
                } else {
                    Toast({
                        message: '该内容不存在～',
                        duration: 2000,
                        onClose: function () {
                            that.$router.push({
                                path: '/',
                                query: {
                                    from: that.$route.query.from
                                }
                            })
                        }
                    })
                }
            });
        },
    },
    components: {
        Auction,
        DownLoadApp,
        gyBox,
        panel,
        watermark
    }
};
</script>

<style lang="scss" scoped>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/swiper.css");

.header {
    height: 2.2rem;
    background: #ffffff;
}

.greenHeader {
    position: relative;
    background: linear-gradient(to right, #F2F3F3, #E6EFEC);
}

.header h3 {
    margin-left: 2.2rem;
    margin-right: 2.2rem;
    text-align: center;
    font-size: 0.9rem;
    line-height: 2.2rem;
    color: #27282d;
}

.header .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_light@2x.png) no-repeat;
    background-size: cover;
}

.header .icon_share {
    width: 2.2rem;
    height: 2.2rem;
    float: right;
    background: url("../../assets/img/icon_nav_share_white@3x.png") no-repeat;
    background-size: cover;
}

.greenHeader .goBack {
    float: left;
    width: 2.2rem;
    height: 2.2rem;
    background: url(../../assets/img/icon_nav_return_white@2x.png) no-repeat;
    background-size: cover;
}

.page {
    width: 18.75rem;
    margin: 0 auto;
}

.speDetail {
    position: relative;
    margin-top: -1px;
}

.speDetail .imgCenter {
    display: flex;
    width: 4.35rem;
    height: 4.35rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 0.35rem 0rem rgba(0, 0, 0, 0.35);
    position: absolute;
    top: 0;
    left: 0.5rem;
}

.speDetail .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.speDetail .speName {
    padding-left: 5.35rem;
    // padding-right: 2.75rem;
    height: 2.15rem;
    background: linear-gradient(to right, #F2F3F3, #E6EFEC);
    font-size: 0.8rem;
    font-weight: 400;
    color: #000;
    line-height: 1.1rem;

    img {
        height: 0.8rem;
    }
}

.followBox {

    position: absolute;
    right: 2rem;
    top: 0.5rem;

    img {
        width: 1.2rem;
        vertical-align: top;
    }

}

.speDetail .speInfo {
    position: relative;
    min-height: 3rem;
    padding-top: 0.4rem;
    padding-bottom: 0.3rem;
    padding-left: 5.35rem;
    padding-right: 1.55rem;
    background: #ffffff;
    font-size: 0.65rem;
    font-weight: 400;
    color: #969696;
    line-height: 0.9rem;

}

.speDetail .speInfo p {
    margin-bottom: 0.25rem;
    overflow: hidden; //多出部分隐藏
    white-space: nowrap; //一行显示
    text-overflow: ellipsis; //是否显示省略号
}

.speDetail .speInfo .moreBtn {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    margin-top: -0.4rem;
    width: 0.8rem;
    height: 0.8rem;
    background: url(../../assets/img/icon_detial_arrow.png) no-repeat;
    background-size: cover;
}

.speBox {
    margin-top: 0.25rem;
    background: #ffffff;
    padding-bottom: 0.5rem;
}

.speBox .swiper-slide {}

.speBox .swiper-slide li {
    height: 2.3rem;
    padding: 0 0.6rem 0 0.75rem;
}

.speBox .swiper-slide a {
    display: block;
    height: 100%;
    position: relative;
}

.speBox .swiper-slide .icon {
    position: absolute;
    top: 0.55rem;
    left: 0;
    width: 1.2rem;
    height: 1.2rem;
    background: url(../../assets/img/icon_pai@2x.png) no-repeat;
    background-size: cover;
}

.speBox .swiper-slide .text {
    display: block;
    width: 13rem;
    margin: 0 auto;
    font-size: 0.7rem;
    line-height: 2.3rem;
    color: #27282e;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.speBox .swiper-slide .button {
    position: absolute;
    right: 0.6rem;
    top: 0.65rem;
    width: 2.2rem;
    height: 1rem;
    background: #ffffff;
    border-radius: 0.53rem;
    border: 0.03rem solid #18bd6f;
    text-align: center;
    line-height: 1rem;
    font-size: 0.6rem;
    color: #18bd6f;
}

.speBox .swiper-pagination {
    position: relative;
}

/deep/ .speBox .swiper-pagination-bullet {
    width: 0.2rem;
    height: 0.2rem;
    background: #dddee3;
    opacity: 1;
}

/deep/ .speBox .swiper-pagination-bullet-active {
    width: 0.6rem;
    border-radius: 0.1rem;
    background: #18bd6f;
}

/deep/ .speBox.swiper-container-horizontal>.swiper-pagination-bullets {
    bottom: 0;
}

.speList {
    margin-top: 0.25rem;
    background: #ffffff;
}

.speList ul {
    padding: 0 0.75rem;
}

.speList li {
    padding: 0.75rem 0;
    border-bottom: 0.05rem solid #dddee3;
}

.speList li:last-child {
    border-bottom: none;
}

.speList li dt {
    width: 3.75rem;
    height: 5rem;
    border-radius: 0.2rem;
    overflow: hidden;
    position: relative;
    float: left;
}

.speList li dt .imgCenter {
    width: 100%;
    height: 100%;
    display: flex;
    background: #f5f5f5;
}

.speList li dt .imgCenter img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.speList li dd {
    margin-left: 4.25rem;
}

.speList li dd h3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    font-size: 0.8rem;
    line-height: 1.1rem;
    color: #27282d;
}

.speList li dd h3 .status {
    width: 1.9rem;
    height: 0.7rem;
    display: inline-block;
    vertical-align: -0.1rem;
    margin-right: 0.2rem;
}

// 待拍卖
.speList li dd h3 .status1 {
    background: url(../../assets/img/icon_list_tag_green@2x.png) no-repeat;
    background-size: cover;
}

// 拍卖中
.speList li dd h3 .status2 {
    background: url(../../assets/img/icon_list_tag_red@2x.png) no-repeat;
    background-size: cover;
}

// 已结拍
.speList li dd h3 .status3 {
    background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
    background-size: cover;
}

// 预展中
.speList li dd h3 .status4 {
    background: url(../../assets/img/icon_list_tag_green.png) no-repeat;
    background-size: cover;
}

// 待预展
.speList li dd h3 .statu5 {
    background: url(../../assets/img/icon_list_tag_grey@2x.png) no-repeat;
    background-size: cover;
}

.speList li dd .tags {
    margin-top: 0.3rem;
    // height: 0.9rem;
    font-size: 0;
}

.speList li dd .tags span {
    padding: 0 0.2rem;
    height: 0.9rem;
    display: inline-block;
    border-radius: 0.1rem;
    border: 0.03rem solid #d8d8d8;
    font-size: 0.55rem;
    color: #969696;
    line-height: 0.9rem;
    margin-right: 0.3rem;
}

.speList li dd .speItem {
    margin-top: 0.5rem;
    font-size: 0.65rem;
    color: #969696;
    line-height: 0.9rem;
}

.speList li dd .speItem .item {
    margin-bottom: 0.15rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-left: 0.95rem;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 0.65rem;
}

.speList li dd .speItem .icon1 {
    background-image: url(../../assets/img/icon_lot.png);
}

.speList li dd .speItem .icon2 {
    background-image: url(../../assets/img/icon_clock.png);
}

.speList li dd .speItem .icon3 {
    background-image: url(../../assets/img/icon_list_add_light@2x.png);
}

.speList li dt .num {
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    padding: 0 0.2rem;
    border-radius: 0.1rem;
    background: #101415;
    font-size: 0.6rem;
    line-height: 0.75rem;
    color: #ffffff;
}

.speList li dt .HDPic {
    position: absolute;
    top: 0;
    right: 0;
    width: 1.3rem;
    height: 0.6rem;
    background: url(../../assets/img/hd_list_icon.png) no-repeat;
    background-size: 100% 100%;
}

.speList li dt .live {
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;
    height: 1rem;
    background: #18bd6f url(../../assets/img/live.gif) no-repeat;
    font-size: 0.55rem;
    line-height: 1rem;
    background-size: cover;
    color: #ffffff;
}

.speList li dt .review {
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    width: 100%;
    height: 1rem;
    background: rgba(0, 0, 0, 0.85);
    font-size: 0.55rem;
    line-height: 1rem;
    color: #ffffff;
}

.meetingList {
    margin-top: .25rem;
}

.meetingList /deep/.van-tab {
    font-size: .75rem;
    line-height: 1.05rem;
}

.meetingList /deep/.van-tab--active {
    color: #18BD6F;
}

.meetingList /deep/.van-tabs__line {
    width: 1.5rem;
    height: .15rem;
    background-color: #18BD6F;
}

.meetingList /deep/.van-tabs--line .van-tabs__wrap {
    height: 2.2rem;
    border-bottom: .05rem solid #dddee3;
}

.loading {
    padding: 1rem 0;
    text-align: center;
}
</style>
